document.addEventListener('turbolinks:before-visit', function() {
  window.turbolinks_referer = location.href;
});

document.addEventListener('turbolinks:load', function() {
  if (window.turbolinks_referer) {
    if (window.yaCounter48610400) {
      window.yaCounter48610400.hit(location.href, document.querySelector('title').text.trim(), window.turbolinks_referer);
    }

    if (window.yaCounter51051866) {
      window.yaCounter51051866.hit(location.href, document.querySelector('title').text.trim(), window.turbolinks_referer);
    }
  }
});

window.dataLayer = window.dataLayer || [];
